"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MOBILE_BREAK_POINT = void 0;
var MOBILE_BREAK_POINT = '(min-width:992px)';
exports.MOBILE_BREAK_POINT = MOBILE_BREAK_POINT;